import React from 'react'
import logo from '../images/person.png'

function Splash() {
  return (
    <div className='bg-[#1b3f69] flex flex-col items-center justify-center h-screen w-screen'>
       <img className='w-[30%] h-[30%] object-contain flex items-center -mt-0.5  hover:opacity-100' src={logo} />

       <h6 className='text-[15px] font-bold text-white -mt-10 md:mt-2'>Welcome To LAW ADVOCATE TRACKER</h6> 

    </div>
  )
}

export default Splash